import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { ReactComponent as BrowsingImage } from '../images/browsing.svg'

const useStyles = makeStyles(theme => ({
    pageContainer: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        margin: '32px',
    },
    imageContainer: {
        maxWidth: '600px',
        marginBottom: '32px',
    },
    image: {
        height: '100%',
        width: '100%',
    },
}))

const NoAccess = () => {
    const classes = useStyles()
    return (
        <div className={classes.pageContainer}>
            <div className={classes.imageContainer}>
                <BrowsingImage className={classes.image} />
            </div>
            <p data-testid='page-text'>
                Your service does not have access to{' '}
                <strong>User Profile</strong>
            </p>
        </div>
    )
}

export default NoAccess
